'use client'
import { createPortal } from 'react-dom'

import type { ReactNode } from 'react'

interface PortalProps {
  children: ReactNode
  targetId?: string
}

const Portal = ({ children, targetId = 'body' }: PortalProps) => {
  const element = typeof window !== 'undefined' && document.querySelector(targetId)
  return element && children ? createPortal(children, element) : null
}

export default Portal
